import type { AxiosResponse } from 'axios'
import api from '..'

export async function getInboxUnread(email: string): Promise<number> {
  try {
    const res: AxiosResponse = await api.get('/agent/unread', {
      params: { email },
    })

    // axios puts the parsed body on `res.data`
    if (res.status < 200 || res.status >= 300) {
      console.error(
        'Failed to fetch /api/agent/unread',
        res.status,
        res.statusText,
      )
      return 0
    }

    const data = res.data
    if (data && typeof data.count === 'number') return data.count
    return 0
  } catch (err) {
    console.error('getInboxUnread error', err)
    return 0
  }
}
